import { getSdk } from "./sdkService";

// TODO: Add comments
export async function getPaymentMethod(planId) {
  try {
    const sdk = await getSdk();
    const result = await sdk.billingManager.getPaymentMethod(planId);
    return result;
  } catch (error) {
    throw error;
  }
}

export async function getPaymentMethodByPlanid(planId) {
  /*const  paymentMethodInfo= await getPaymentMethod.call(this);
  const paymentPlan = ((paymentMethodInfo && paymentMethodInfo.paymentPlans) || []).find(plan => plan.id === planId);
  */
 const sdk = await getSdk();
  const paymentPlan = await sdk.billingManager.getPaymentMethodById(planId);
  return paymentPlan;
  }
